rjm.ui.ChartBuilderTrendListView = Backbone.View.extend(
  events:
    "change #trendList": "changeTrend"
    "change #gaTrendList" : "changeGATrend"
    "click  #cohortMode": "changeCohortMode"

  initialize: (options) ->
    if not options.hasOwnProperty("viewState") or
        not options.hasOwnProperty("model") or
        not options.hasOwnProperty("clientId") or
        not options.hasOwnProperty("gaConnectionsCollection")
      throw "InvalidConstructorArgs - ChartBuilderTrendListView"

    _.bindAll this, "render", "generateTemplateData", "changeTrend", "changeCohortMode"

    @gaConnectionsCollection = options.gaConnectionsCollection
    @viewState = options.viewState
    @model = options.model
    @clientId = options.clientId
    @isTooltipVisible = false
    @seedTrendId = options.seedTrendId
    @cohortDefault = options.cohortDefault

    # Load in the collection
    @trendCollection = new rjm.model.TrendList([],
      client: @clientId
    )

    # Set loading to true while we're waiting for the metrics to come back
    @trendCollection.loading = true

    # Load in the GA collection
    @gaTrendsCollection = new rjm.model.GATrendList([],
      client: @clientId
    )

    # Set loading to true while we're waiting for the metrics to come back
    @gaTrendsCollection.loading = true

    @listenTo @trendCollection, "reset", (collection) =>
      @seedTrend()
      collection.loading = false
      @render()
    @trendCollection.fetch()

    @listenTo @gaTrendsCollection, "reset", (collection) =>
      collection.loading = false
      @render()
    @gaTrendsCollection.fetch()

    @listenTo @model.getCurrentSeries(), "change", @render

    return

  seedTrend: ->
    #pre-select the trend
    if not @viewState.get('trendsOnly') and @viewState.get('isCreate')
      @model.changeTrend(@trendCollection.get(@seedTrendId))

  _disableIfNotCohort: (trendModel) ->
    unless trendModel.get('hasCohorts')
      trendModel.set('disabled', true)

  _getTrendModels: (trendModels) ->
    if @cohortDefault
      @_disableIfNotCohort(trendModel) for trendModel in trendModels
    return @trendCollection.models

  generateTemplateData: ->
    trendModels: if @trendCollection.size() > 0 then @_getTrendModels(@trendCollection.models) else null
    gaConnectionModels: @gaConnectionsCollection.models
    gaCategorizedTrendModels: if @gaTrendsCollection.size() > 0 then @gaTrendsCollection.getByCategory() else null
    introText: if @model.isCohortChart() and not @model.isGAChart() then 'Cohort Analysis of' else 'Show'
    isGAChart: @model.isGAChart()
    cohortModeText: if @model.isCohortChart() then "Exit Cohort Analysis" else "Perform Cohort Analysis"
    displayCohortText: !@cohortDefault && !@model.isGAChart()

  changeGATrend: (e) ->
    e.preventDefault()
    newTrendId = $(e.target).val()
    @model.changeTrend @gaTrendsCollection.get(newTrendId)
    @unblockContainerView()
    @render()

  changeTrend: (e) ->
    e.preventDefault()
    newTrendId = $(e.target).val()
    if newTrendId.indexOf('ga') is 0
      newTrendId = newTrendId.substring(2)
      @$(".gaTrends").show()
      @gaConnection = @gaConnectionsCollection.get(newTrendId)
      @model.setGAConnection(@gaConnection.get('id'))
      @$("#cohortMode").hide()
    else
      @$(".gaTrends").hide()
      @model.changeTrend @trendCollection.get(newTrendId)
      if @model.getCurrentSeries().get("trend").get("hasCohorts")
        @$('#cohortMode').show()

      @unblockContainerView()

      # If we're in cohortDefault mode, and we can, choose cohortMode.
      if @cohortDefault and @model.getCurrentSeries().get("trend").get("hasCohorts")
        @model.cohortMode()
      else if @model.isCohortChart()
        @model.removeCohort()

    @render()

    return

  changeCohortMode: (e) ->
    e.preventDefault()
    if @model.isCohortChart()
      @model.removeCohort()
    else
      @model.cohortMode()
    @render()

  unblockContainerView: ->
    if @viewState.get("trendsOnly")
      @viewState.set trendsOnly: false

  render: ->
    @$("#s2id_trendList").find("b").tooltip "destroy"
    @$el.html ich.chartBuilderTrendList(@generateTemplateData())

    @$(".gaTrends").hide() if not @model.isGAChart()

    @$("#trendList").select2
      placeholder: "Choose a Metric"
      dropdownCssClass: "bigdrop"

    @$("#gaTrendList").select2(
      placeholder: "Choose a Google Analytics Metric"
      dropdownCssClass: "bigdrop"
    )

    if @model.isGAChart()
      gaConnection = @gaConnectionsCollection.get(@model.get('api_conn_id'))
      @$("#trendList").select2("val", gaConnection.get('gaid'))
      if @viewState.get("trendsOnly")
        if gaConnection.attributes.prettyConnectionType is 'Google Analytics 4 Live'
          $("#gaTrendList").prop("disabled", true)
        else
          $("#gaTrendList").prop("disabled", false)
        @$("#gaTrendList").select2("val", '')
      else
        @$("#gaTrendList").select2("val", @model.getCurrentSeries().get("trend")?.get("id"))
    else if @model.isCohortChart()
      @$(".prose:first-child").addClass('cohort')
      @$("#trendList").select2("val", @model.getCurrentSeries().get("trend")?.get("id"))
    else if @viewState.get("trendsOnly")
      @$("#trendList").select2("val", '')
    else
      @$("#trendList").select2("val", @model.getCurrentSeries().get("trend")?.get("id"))

    if @isTooltipVisible
      @$("#s2id_trendList").find("b").tooltip "show"

    if not @model.getCurrentSeries().get("trend")?.get("hasCohorts") or
        @viewState.get("trendsOnly")
      @$("#cohortMode").hide()

    # We may have no metrics, but we may have GA access.  Make sure we only block this if we're missing both
    if @trendCollection.loading
      @$('#s2id_trendList').addClass("blocked loading")
      @$('#cohortMode').addClass "blocked"

    if @gaTrendsCollection.loading
      @$('#s2id_gaTrendList').addClass("blocked loading")

    return @
)
